import { z } from 'zod';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const phoneNumberValidationSchema = z
  .object({
    dialCode: z.string().min(1, 'Kod kraju jest wymagany'),
    number: z.string().min(1, 'Numer telefonu jest wymagany'),
  })
  .refine(
    (val) => {
      const fullNumber = val.dialCode + val.number;
      const phoneNumber = parsePhoneNumberFromString(fullNumber);
      return phoneNumber?.isPossible() ?? false;
    },
    {
      message: 'Nieprawidłowy format numeru telefonu',
    },
  );

export const lastNameValidationSchema = z
  .string()
  .min(1, 'Nazwisko jest wymagane')
  .min(2, 'Nazwisko musi mieć co najmniej 2 znaki');

export const firstNameValidationSchema = z
  .string()
  .min(1, 'Imię jest wymagane')
  .min(2, 'Imię musi mieć co najmniej 2 znaki');

export const birthDateValidationSchema = z.date({
  error: 'Data urodzenia jest wymagana',
});

export const emailValidationSchema = z.email({
  error: 'Podaj poprawny adres e-mail',
});

// Updated postal code validation (With what? I just moved it here)
const postalCodeRegex = /^\d{2}-\d{3}$/;
export const postalCodeValidationSchema = z
  .string()
  .min(1, 'Kod pocztowy jest wymagany')
  .refine(
    (val) => postalCodeRegex.test(val),
    'Kod pocztowy musi mieć format XX-XXX',
  );

export const addressValidationSchema = z.string().min(1, 'Adres jest wymagany');

export const cityValidationSchema = z.string().min(1, 'Miasto jest wymagane');
